/* eslint-disable no-useless-catch */
import Vue from "vue";
import { sortBy } from "lodash";

export default function makeListingMixin(type: any, apiCall: any) {
	return (store: any = {}) => {
		return {
			...store,
			state: {
				...store.state,
				lastFetched: null, // Timestamp
				byID: {}, // Lookup for Users
				isFetching: false,
				errorMessage: null,
				lastSearch: {}
			},
			mutations: {
				[`${type}sLoadStart`](state: any) {
					state.errorMessage = null;
					state.isFetching = true;
				},
				[`${type}sLoadSuccess`](state: any, things: any[] = [], search: any) {
					let sort = 1;
					const byID = things.reduce((acc, val) => {
						val.sort = sort++;
						acc[val.id] = val;
						return acc;
					}, {});
					Vue.set(state, "byID", byID);
					state.lastFetched = Date.now();
					state.isFetching = false;
					state.lastSearch = search;
				},
				[`${type}sLoadFailure`](state: any, error: string) {
					state.errorMessage = error;
					state.isFetching = false;
				},
				[`${type}LoadStart`](state: any) {
					state.errorMessage = null;
					state.isFetching = true;
				},
				[`${type}LoadSuccess`](state: any, thing: any) {
					if (!thing) return;
					Vue.set(state.byID, thing.id.toString(), thing);
					state.isFetching = false;
				},
				[`${type}LoadFailure`](state: any, error: string) {
					state.errorMessage = error;
					state.isFetching = false;
				},
				[`${type}InsertStart`]() {},
				[`${type}InsertSuccess`](state: any, thing: any) {
					Vue.set(state.byID, thing.id.toString(), thing);
				},
				[`${type}InsertFailure`]() {},
				[`${type}UpdateStart`]() {},
				[`${type}UpdateSuccess`](state: any, thing: any) {
					Vue.set(state.byID, thing.id.toString(), thing);
				},
				[`${type}UpdateFailure`]() {},
				[`${type}DeleteSuccess`](state: any, id: number) {
					Vue.delete(state.byID, id);
				},
				[`${type}sClear`](state: any) {
					state.byID = {};
					// Vue.set(state.byID, thing.id.toString(), thing);
				},
				...store.mutations
			},
			getters: {
				[`${type}sShouldFetch`]: (state: any) => {
					// TODO: add timestamp check here.
					return !state.lastFetched;
				},
				[`${type}sIsFetching`]: (state: any) => {
					return state.isFetching;
				},
				[`${type}sList`]: (state: any) => {
					if (state.byID) {
						return sortBy(Object.values(state.byID), ["sort"]);
					}
					return null;
				},
				[`${type}Get`]: (state: any) => (id: number) => {
					return state.byID[id];
				},
				[`${type}sHasFetched`]: (state: any) => {
					return !!state.lastFetched;
				},
				...store.getters
			},
			actions: {
				async [`${type}sLoad`](context: any, search: any) {
					context.commit(`${type}sLoadStart`);
					try {
						const things = await apiCall(null, null, search);
						context.commit(`${type}sLoadSuccess`, things, search);
					} catch (error) {
						context.commit(`${type}sLoadFailure`, error.message);
						throw error;
					}
				},
				// eslint-disable-next-line
				async [`${type}Load`](context: any, {
					id,
					force
				}: any) {
					// Do we already have the user?
					// if (!force && context.getters[`${type}Get`](id)) return;

					context.commit(`${type}LoadStart`);
					try {
						const thing = await apiCall("get", {
							id
						});
						context.commit(`${type}LoadSuccess`, thing);
					} catch (error) {
						context.commit(`${type}LoadFailure`, error.message);
						throw error;
					}
				},
				async [`${type}Insert`](context: any, thing: any) {
					context.commit(`${type}InsertStart`, thing);
					try {
						const _thing = await apiCall("post", thing);
						context.commit(`${type}InsertSuccess`, _thing);
						return _thing;
					} catch (error) {
						context.commit(`${type}InsertFailure`, thing);
						// Just rethrowing error for the moment.
						// will set isFetching to be false here though
						throw error;
					}
				},
				async [`${type}Update`](context: any, thing: any) {
					context.commit(`${type}UpdateStart`, thing);
					try {
						const result = await apiCall("PUT", thing);
						context.commit(`${type}UpdateSuccess`, result);
					} catch (error) {
						// Just rethrowing error for the moment.
						console.log(error);
						throw error;
					}
				},
				async [`${type}Delete`](context: any, id: number) {
					try {
						await apiCall("delete", {
							id
						});
						context.commit(`${type}DeleteSuccess`, id);
					} catch (error) {
						// Just rethrowing error for the moment.
						// will set isFetching to be false here though
						console.log(error);
						throw error;
					}
				},
				[`${type}sClear`](context: any) {
					context.commit(`${type}sClear`);
				},
				...store.actions
			}
		};
	};
} // eslint-disable-line
